import Vue from "vue";
import Vuex from "vuex";
const axios = require("axios");

import { projectFirestore, timestamp } from "@/firebase/config";

import { projectAuth } from "@/firebase/config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    backgroundImage: {
      id: 123,
      urls: {
        full:
          "https://images.unsplash.com/photo-1615752593230-fe3329d89541?crop=entropy&cs=srgb&fm=jpg&ixid=Mnw3MDY0fDB8MXxyYW5kb218fHx8fHx8fHwxNjE2MDM1NzY4&ixlib=rb-1.2.1&q=85",
        thumb:
          "https://images.unsplash.com/photo-1615194144343-d2c10f8e5350?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=Mnw3MDY0fDB8MXxyYW5kb218fHx8fHx8fHwxNjE1MzQ0MjI5&ixlib=rb-1.2.1&q=80&w=200"
      },
      links: {
        self: "https://api.unsplash.com/photos/W-RAejgfkDA",
        html: "https://unsplash.com/photos/W-RAejgfkDA"
      },
      user: {
        name: "Juho Luomala",
        links: {
          html: "https://unsplash.com/@juho_aleksi_luomala"
        }
      },
      location: {
        title: "Kalajoki, Suomi"
      }
    },
    editor: false,
    notes: [],
    error: {
      type: "danger",
      value: ""
    },
    user: null,
    metadata: null
  },
  getters: {
    getBackgroundImageUrl: state => state.backgroundImage.urls.full,
    getBackgroundImage: state => state.backgroundImage,
    getEditor: state => state.editor,
    getNotes: state => state.notes,
    getNote: state => id => {
      const match = state.noteilter(note => {
        return note.id === id;
      });
      return match[0];
    },
    getError: state => state.error,
    getUser: state => state.user,
    getMetadata: state => state.metadata,
    getCategories(state) {
      let categories = [];
      state.metadata.noteSummaries.forEach(note => {
        if (!categories.includes(note.category)) categories.push(note.category);
      });
      return categories;
    }
  },
  mutations: {
    UPDATE_EDITOR: (state, editor) => {
      state.editor = editor;
    },
    SET_NOTES: (state, notes) => {
      state.notes = notes;
    },
    ADD_FAVOURITE_IMAGE: (state, image) => {
      state.metadata.favouriteImages.push(image);
    },
    mutate(state, payload) {
      state[payload.property] = payload.with;
    }
  },
  actions: {
    async fetchBackgroundImage({ commit }) {
      try {
        let res = await axios.get("/api/image");
        console.log(res.data);
        commit("mutate", {
          property: "backgroundImage",
          with: res.data
        });
      } catch (e) {
        console.error(e);
      }
    },
    fetchUser({ commit, dispatch }) {
      projectAuth.onAuthStateChanged(_user => {
        console.log(_user);
        commit("mutate", {
          property: "user",
          with: _user
        });
        dispatch("fetchUserMetadata", _user.uid);
      });
    },
    async fetchUserMetadata({ commit, dispatch, state }, uid) {
      try {
        const res = await projectFirestore
          .collection("metadata")
          .where("uid", "==", uid)
          .get();
        const unsubscribe = projectFirestore
          .collection("metadata")
          .where("uid", "==", uid)
          .onSnapshot(snap => {
            let userMetadata = snap.docs[0].data();
            userMetadata.id = snap.docs[0].id;
            console.log("snapshot updated");
            commit("mutate", {
              property: "metadata",
              with: userMetadata
            });
          });
        let userMetadata = res.docs[0].data();
        userMetadata.id = res.docs[0].id;
        commit("mutate", {
          property: "metadata",
          with: userMetadata
        });
        // First time only generate noteSummaries
        if (!state.metadata.updates) {
          dispatch("syncNoteSummaries");
        }

        return unsubscribe;
      } catch (e) {
        console.error(e);
      }
    },
    async syncNoteSummaries({ dispatch, state }) {
      await dispatch("fetchNotes");
      console.log(state.notes);
      let newNoteSummaries = state.notes.map(({ title, id, category }) => {
        return {
          title,
          noteId: id,
          category
        };
      });
      console.log(newNoteSummaries);
      await projectFirestore
        .collection("metadata")
        .doc(state.metadata.id)
        .set({
          ...state.metadata,
          noteSummaries: newNoteSummaries,
          updates: { noteSummaries: true }
        });
    },
    async createNote({ state }) {
      console.log(state.user.uid);
      const newNote = {
        title: "",
        body: "",
        tags: [],
        category: "",
        createdAt: timestamp(),
        lastEdited: timestamp(),
        uid: state.user.uid
      };
      const { id } = await projectFirestore.collection("notes").add(newNote);
      return id;
    },
    async updateNote({ dispatch }, note) {
      console.log(note);
      note.lastEdited = timestamp();
      if (note.category === "") note.category = "Uncategorized";
      await projectFirestore
        .collection("notes")
        .doc(note.id)
        .set(note);
      dispatch("fetchUserMetadata", note.uid);
    },
    async fetchNote({ commit, state }, id) {
      console.log(id);
      try {
        const doc = await projectFirestore
          .collection("notes")
          .doc(id)
          .get();
        const newNotes = state.notes.filter(note => note.id !== id);
        commit("SET_NOTES", newNotes); // ??????????
        if (doc.exists) {
          const note = { ...doc.data(), id: doc.id };
          return note;
        } else {
          console.error("No such document!");
        }
      } catch (e) {
        console.error(e);
      }
    },
    async deleteNote({ state, commit }, id) {
      try {
        await projectFirestore
          .collection("notes")
          .doc(id)
          .delete();
        const newNotes = state.notes.filter(note => note.id !== id);
        commit("mutate", { property: "notes", with: newNotes });
      } catch (err) {
        console.error(err);
      }
    },
    async fetchNotes({ state, commit }, page) {
      console.log(page);
      const lastNote = state.notes[state.notes.length - 1];
      console.log(lastNote);
      try {
        const res = await projectFirestore
          .collection("notes")
          .where("uid", "==", state.user.uid)
          .orderBy("lastEdited", "asc")
          // .limit(30)
          .get();
        const notes = res.docs.map(doc => {
          return { ...doc.data(), id: doc.id };
        });
        console.log(notes);
        commit("SET_NOTES", notes);
      } catch (e) {
        console.error(e.message);
      }
    },
    setEditor(context, editor) {
      context.commit("UPDATE_EDITOR", editor);
    },
    async sendPasswordResetEmail(context, email) {
      console.log(email);
      try {
        await projectAuth.sendPasswordResetEmail(email);
      } catch (err) {
        console.error(err);
      }
    },
    async addToFavourites({ state, commit }, image) {
      console.log(state.metadata.favouriteImages);
      console.log(typeof state.metadata.favouriteImages);
      console.log(image);
      console.log([...state.metadata.favouriteImages, image]);
      if (
        !state.metadata.favouriteImages.filter(img => img.id === image.id)
          .length
      ) {
        await projectFirestore
          .collection("metadata")
          .doc(state.metadata.id)
          .update({
            favouriteImages: [...state.metadata.favouriteImages, image]
          });
        commit("ADD_FAVOURITE_IMAGE", image);
      } else {
        console.error("already saved");
      }
    }
  }
});
